import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// namespace های بخش client
import faCommon from "./locales/fa/common.json";
import faClient from "./locales/fa/client.json";
import faUser from "./locales/fa/user.json";
import enCommon from "./locales/en/common.json";
import enClient from "./locales/en/client.json";
import enUser from "./locales/en/user.json";
import arCommon from "./locales/ar/common.json";
import arClient from "./locales/ar/client.json";
import arUser from "./locales/ar/user.json";
import faLanding from "./locales/fa/landing.json";
import enLanding from "./locales/en/landing.json";
import arLanding from "./locales/ar/landing.json";

export const RTL_LANGUAGES = ["fa", "ar"];

export const SUPPORTED_LANGUAGES = [
  { code: "fa", label: "فارسی" },
  { code: "ar", label: "العربية" },
  { code: "en", label: "English" },
];

const resources = {
  fa: { common: faCommon, client: faClient, user: faUser, landing: faLanding },
  en: { common: enCommon, client: enClient, user: enUser, landing: enLanding },
  ar: { common: arCommon, client: arClient, user: arUser, landing: arLanding },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fa",
    supportedLngs: ["fa", "en", "ar"],
    ns: ["common", "client", "user", "landing"],
    defaultNS: "client",
    interpolation: {
      escapeValue: false, // React خودش XSS رو هندل می‌کنه
    },
    detection: {
      // اول از localStorage بخون؛ کلید سفارشی خودمون رو زیر معرفی می‌کنیم
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "rayabot-client-lang",
      caches: ["localStorage"],
    },
  });

export default i18n;